import {
  ClientSyncResponse,
  IClientData,
  IClientDetailData,
  IClientParams,
  IClientSyncResponse,
  IUpdateClient,
} from "@/entities";
import {
  BACKEND_BASE_URL,
  IClientService,
  IClientsReportRequest,
  IGenericResponse,
  IPageResponse,
  IResponseError,
} from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class ClientService implements IClientService {
  async getClients(params?: IClientParams): Promise<IPageResponse<IClientData> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<IClientData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/client`, { params })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getClientDetail(idClient: number): Promise<IClientDetailData | undefined> {
    const { response, error } = await handleResponse<IClientDetailData, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/client/${idClient}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async saveUpdateClient(
    updateClient: IUpdateClient
  ): Promise<IGenericResponse<IClientDetailData> | undefined> {
    const { response, error } = await handleResponse<
      IGenericResponse<IClientDetailData>,
      IResponseError
    >(Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/client`, updateClient));
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async updateStatusClient(idClient: number): Promise<number | undefined> {
    const { response, error } = await handleResponse<number, IResponseError>(
      Vue.$axios.patch(`${BACKEND_BASE_URL}/api/configuration/v1/client/${idClient}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async postGenerateClientsReport(request?: IClientsReportRequest): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/report/client`, request)
    );
  }

  async syncClient(id: number): Promise<IClientSyncResponse | undefined> {
    const { response, error } = await handleResponse<IClientDetailData, IResponseError>(
      Vue.$axiosSilentLoading.post(`${BACKEND_BASE_URL}/api/configuration/v1/client/${id}/sync`)
    );
    if (error) {
      const errorData = error.response;
      if (errorData?.status != 500 && errorData?.data) {
        return new ClientSyncResponse(false, null, errorData?.data?.message);
      }
      return undefined;
    } else {
      return new ClientSyncResponse(true, response!.data);
    }
  }
}
